import { getProfile } from "@/apis/naniclub/services/users";
import type { UserProfileSource } from "../types";

export const naniClubUserProfileSource: UserProfileSource = {
  key: "naniclub",
  fetchProfile: async () => {
    const { fullName } = await getProfile();

    return { fullName };
  },
};
